import React from 'react';

import {
  useClearNotificationEffect,
  useOverideCssVariableEffect,
} from '../shared/hooks';
import ColorInput from '../shared/ColorInput';
import StatusLabel from '../shared/StatusLabel';
import { isColorValid } from '../utils';

const ARIA_BASE = 'company_settings_secondary_color';

const SettingsSecondaryColor = ({
  name,
  error,
  success,
  onChange,
  color,
  savedColor,
  defaultColor = '',
  clearSuccess,
}) => {
  const onColorChange = value =>
    onChange(name, value, { settings: { color_secondary: value } });

  useOverideCssVariableEffect(
    'color-secondary',
    isColorValid(color) ? color : savedColor,
  );

  useClearNotificationEffect(success, name, clearSuccess);

  return (
    <div className="mb-24">
      <div className="d-f mb-8">
        <label
          htmlFor="company_settings_secondary_color"
          className="d-f ai-c jc-c mb-0 lh-24"
        >
          {t('settings.tab.customization.secondary_color.title')}
        </label>
        <StatusLabel
          id={`${ARIA_BASE}_status`}
          success={success}
          error={error}
        />
      </div>
      <div className="d-f">
        <ColorInput
          id={ARIA_BASE}
          ariaDescribedBy={`${ARIA_BASE}_status`}
          placeholder={defaultColor}
          value={color}
          name={name}
          onChange={e => onColorChange(e.target.value)}
        />
      </div>
      <br />
      <button
        type="button"
        className="NewButton NewButton--gray"
        onClick={() => onColorChange(defaultColor)}
      >
        {t('settings.tab.customization.secondary_color.reset_button_text')}
      </button>
    </div>
  );
};

export default props => <SettingsSecondaryColor {...props} />;
